import { render, staticRenderFns } from "./background-gradient.vue?vue&type=template&id=38bbc278&"
import script from "./background-gradient.vue?vue&type=script&lang=js&"
export * from "./background-gradient.vue?vue&type=script&lang=js&"
import style0 from "./background-gradient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports